import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "9627cffd-d836-41e8-a26e-4e42916dcf80",
    content: "The microphone generates an electrical signal at twice the excitation frequency",
    options: {},
  },
  {
    id: "fb5e0e70-9e00-4086-8425-d1147a4a9fd2",
    content: "The microphone generates an electrical signal at half the excitation frequency",
    options: {},
  },
  {
    id: "2df3a1b1-d754-4c54-a2ef-7de940093467",
    content: "The microphone does not generates any electrical signal",
    options: {},
  },
  {
    id: "4754190b-6b93-4ebd-9649-80d4a69d5272",
    content: "The microphone generates an electrical signal at the excitation frequency",
    options: {},
  },
];

export const task: Task = {
  id: "a3df7162-f80c-4d19-b3dc-bfa2df182815",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["2df3a1b1-d754-4c54-a2ef-7de940093467"],
};
